export const removeLocationData = (menuId, route, navigate) => {
  //
  localStorage.setItem("tempMenuId", menuId);
  let MenuId = JSON.parse(localStorage.getItem("tempMenuId"));
  navigate(route, {
    state: { menuId: MenuId },
  });
};
